import { useContext } from 'react';
import { AuthContext } from '../context/providers/AuthProvider';

export default function useToken() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useToken must be used within an AuthProvider");
    }
    return context;
}